import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const CONFIRM_EMAIL_SCHEMA_FIELDS_NAME = {
  confirmEmail: "confirmEmail",
  email: "email",
};

export const getConfirmEmailFormFieldsSchema = (
  confirmLabel = i18n("ConfirmEmailFormFields__LABEL_CONFIRMATION")
) =>
  yup
    .string()
    .trim()
    .lowercase()
    .oneOf(
      [yup.ref(CONFIRM_EMAIL_SCHEMA_FIELDS_NAME.email)],
      i18n("ConfirmEmailFormFields__ERROR_EMAIL_MISMATCH")
    )
    .label(confirmLabel.toLowerCase());
